import styles from "../style.module.css";
import headerStyles from "../CSS_Module/header.module.css";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../Element_Image/logo.png";

const languageOption = [
  { name: "中文", code: "zh" },
  { name: "English", code: "en" },
];

const Header = ({
  header,
  i18n,
  isLanguageMenuActive,
  setIsLanguageMenuActive,
}) => {
  const handleLanguageSelection = (selectedLanguage) => {
    i18n.changeLanguage(selectedLanguage);
  };

  return (
    <div className={headerStyles.header}>
      <div className={headerStyles.headerContainer}>
        <div className={headerStyles.headerBoxLeft}>
          <Link to="/" style={{ textDecoration: "none" }}>
            <div className={headerStyles.headerBoxLeftContainer}>
              <img className={headerStyles.logo} src={logo} alt="logo" />
              <div className={headerStyles.headerLogoName}>MESOLVER</div>
            </div>
          </Link>
        </div>
        <div className={headerStyles.headerBoxRight}>
          <div
            className={headerStyles.headerOption}
            onClick={() => setIsLanguageMenuActive(!isLanguageMenuActive)}
          >
            {header[1]}
          </div>
          <Link to="/about" style={{ textDecoration: "none" }}>
            <div
              className={headerStyles.headerOption}
              onClick={() => setIsLanguageMenuActive(false)}
            >
              {header[2]}
            </div>
          </Link>
          <Link to="/contact" style={{ textDecoration: "none" }}>
            <div
              className={headerStyles.headerOption}
              onClick={() => setIsLanguageMenuActive(false)}
            >
              {header[3]}
            </div>
          </Link>
          <div
            className={
              isLanguageMenuActive
                ? headerStyles.languageOptionMenu
                : headerStyles.languageOptionMenuInactive
            }
          >
            <div
              className={headerStyles.languageBlurBackground}
              onClick={() => setIsLanguageMenuActive(false)}
            ></div>
            {languageOption.map((option) => (
              <button
                className={headerStyles.languageOption}
                key={option.code}
                onClick={() => handleLanguageSelection(option.code)}
              >
                {option.name}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
